import { Theme } from "@mui/material/styles";

import { Brand, getConfig } from "merchant-portal-frontend/src/config";
import {
	StringKeys,
	ThemeButtonProps,
	ThemeFormProps,
	ThemeIconProps,
	ThemeKPIGradientProps,
	ThemeKPITextProps,
	ThemeLayoutProps,
	ThemeStructureProps,
	ThemeTextProps,
	ThemeTransactionProps,
	ThemeTransactionTextProps,
} from "merchant-portal-theme/ThemeTypes";

import { breadTheme } from "./BreadTheme.config";
import { rbcTheme } from "./RBCTheme.config";

const getThemeFromConfig = () => {
	const brand = getConfig<Brand>("brand", {
		safeReturn: true,
		defaultValue: Brand.Bread,
	});

	return brand === Brand.Bread ? breadTheme : rbcTheme;
};

export const getMainColor = (key: StringKeys<Theme>) => {
	const theme = getThemeFromConfig();
	return theme[key];
};

export const getStructureColor = (key: keyof ThemeStructureProps) => {
	const theme = getThemeFromConfig();
	return theme.structure[key];
};

export const getTextColor = (key: keyof ThemeTextProps) => {
	const theme = getThemeFromConfig();
	return theme.text[key];
};

export const getIconColor = (key: keyof ThemeIconProps) => {
	const theme = getThemeFromConfig();
	return theme.icons[key];
};

export const getFormElementColor = (key: keyof ThemeFormProps) => {
	const theme = getThemeFromConfig();
	return theme.formElements[key];
};

export const getButtonColor = (key: keyof ThemeButtonProps) => {
	const theme = getThemeFromConfig();
	return theme.buttons[key];
};

export const getLayoutColor = (key: keyof ThemeLayoutProps) => {
	const theme = getThemeFromConfig();
	return theme.layout[key];
};

export const getTransactionBGColor = (key: StringKeys<ThemeTransactionProps>) => {
	const theme = getThemeFromConfig();
	return theme.transactions[key];
};

export const getTransactionColor = (key: keyof ThemeTransactionTextProps) => {
	const theme = getThemeFromConfig();
	return theme.transactions.text[key];
};

export const getKPITextColor = (key: keyof ThemeKPITextProps) => {
	const theme = getThemeFromConfig();
	return theme.kpis.text[key];
};

export const getKPIGradientColor = (key: keyof ThemeKPIGradientProps) => {
	const theme = getThemeFromConfig();
	return theme.kpis.gradients[key];
};
